module.exports = __webpack_public_path__ + "img/initial.0bb28b13.svg";